"use strict";

exports.__esModule = true;

var tslib_1 = require("tslib");

var utilities_1 = require("@sportnet/ui/lib/Themes/utilities");

var polished_1 = require("polished");

var react_1 = tslib_1.__importDefault(require("react"));

var styled_components_1 = tslib_1.__importDefault(require("../../../theme/styled-components"));

var Text_1 = tslib_1.__importDefault(require("../FormattedText/Text"));

var Wrapper = styled_components_1["default"].div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  border-radius: ", ";\n  background-color: ", ";\n  padding: ", ";\n"], ["\n  border-radius: ", ";\n  background-color: ", ";\n  padding: ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return theme.largeBorderRadius;
}, function (_a) {
  var _b;

  var theme = _a.theme;
  return utilities_1.emphasizeColor(0.04, ((_b = theme.app) === null || _b === void 0 ? void 0 : _b.bgColor) || '#fff', true);
}, polished_1.rem(24));
var Header = styled_components_1["default"].h2(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  margin-top: 0;\n  margin-bottom: ", ";\n"], ["\n  margin-top: 0;\n  margin-bottom: ", ";\n"])), polished_1.em(22));
var NoMarginText = styled_components_1["default"](Text_1["default"])(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  & > *:first-child {\n    margin-top: 0;\n  }\n  & > *:last-child {\n    margin-bottom: 0;\n  }\n"], ["\n  & > *:first-child {\n    margin-top: 0;\n  }\n  & > *:last-child {\n    margin-bottom: 0;\n  }\n"])));
var ContentLine = styled_components_1["default"].hr(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n  margin: ", " 0 ", " 0;\n  width: ", ";\n  border: none;\n  border-bottom: ", " solid ", ";\n"], ["\n  margin: ", " 0 ", " 0;\n  width: ", ";\n  border: none;\n  border-bottom: ", " solid ", ";\n"])), polished_1.em(32), polished_1.em(14), polished_1.rem(40), polished_1.rem(1), function (_a) {
  var theme = _a.theme;
  return theme.app.textColor;
});

var HighlightedBox = function (_a) {
  var content = _a.content,
      header = _a.header,
      footer = _a.footer;
  return react_1["default"].createElement(Wrapper, null, header && react_1["default"].createElement(Header, null, header), react_1["default"].createElement(NoMarginText, {
    text: content
  }), footer && react_1["default"].createElement(react_1["default"].Fragment, null, react_1["default"].createElement(ContentLine, null), footer));
};

exports["default"] = HighlightedBox;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;